import { Button, Checkbox, Form, Input, message } from 'antd';
import { ReactComponent as EmailIcon } from "../../../assets/svgs/icons/email-icon.svg";
import { ReactComponent as PasswordIcon } from "../../../assets/svgs/icons/password-icon.svg";
import { UserManagerContainer } from '../UserManager.style';
import { Store } from '../../../store/Store';
import { checkLogin } from '../userManagementUtils';
import { useSnapshot } from 'valtio';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const snapShot = useSnapshot(Store);
    const navigate = useNavigate();
    const handleLogin = (values: any) => {
        // Check if the user added the email and password or not
        if (values.email && values.password) {
            Store.isInitialized = false
            if (!values.email.includes("@")) {
                message.warning("Please enter a valid email address.", 2);
                return;
            }
            checkLogin(values.email, values.password).then((res) => {
                Store.isLoggedIn = true;
            }).catch((err) => {
                if (err.code === "UserNotConfirmedException") {
                    navigate('/verify')
                }
                message.error(err.message || "Failed to login.");
                Store.isInitialized = true
            })
        } else {
            message.warning("Please enter email and password!")
        }
    }
    return (
        <UserManagerContainer>
            <div className='login__block'>
                <div className="login_inner_box">
                    <div className='login_inner_top_box'>
                        <h2>LiDAR Atlas</h2>
                    </div>
                    <div className='login_inner_middle_box'>
                        <div className='login_middle_title_box'>
                            <h2>Sign In</h2>
                            <p>Please fill all the mandatory fields to continue</p>
                        </div>
                        <div className='login__form__block'>
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{ remember: false }}
                                onFinish={handleLogin}

                            >
                                <Form.Item
                                    name="email"
                                    rules={[{ required: true, message: 'Please Enter Email!' }]}
                                    className='form_input_field'
                                >
                                    <Input type='email' size="large" prefix={<EmailIcon key="EmailIcon" />} placeholder="Email*" autoComplete="email" />
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    rules={[{ required: true, message: 'Please Enter Password!' }]}
                                    className='form_input_field form_input_field_password'
                                >
                                    <Input
                                        prefix={<PasswordIcon key="PasswordIcon" className="site-form-item-icon" />}
                                        type="password"
                                        size="large"
                                        placeholder="Password*"
                                        autoComplete="new-password"
                                    />
                                </Form.Item>
                                <Form.Item className='forgot__link__box'>
                                <span className="login-form-forgot" onClick={() => { navigate('/reset-password'); }} style={{ cursor: "pointer" }}>
                                    Forgot password
                                </span>
                                </Form.Item>
                                {/* <Form.Item className="remember_password_block" name="remember" valuePropName="checked">
                                    <Checkbox style={{ color: '#ffffff' }}>
                                        <span style={{ color: '#ffffff' }}>Remember me</span>
                                    </Checkbox>
                                </Form.Item> */}
                                <Form.Item>
                                    <Button disabled={snapShot.isInitialized === false} loading={snapShot.isInitialized === false} size='large' htmlType="submit" className="user_control_btn">
                                        Sign in
                                    </Button>
                                </Form.Item>

                            </Form>
                        </div>
                    </div>
                    <div className='login_inner_bottom_box'>
                        <span onClick={() => { navigate('/signup'); }}>Do not have an account? Sign Up</span>
                    </div>
                </div>
            </div>
        </UserManagerContainer>
    );
}

export default Login;
